module.exports = __webpack_public_path__ + "static/media/lock.7fd4828b.svg";